import { addDiscard, removeDiscard } from 'datamodel/discards/api';

export const toggleDiscard = async (token, roomId, isDiscarded) => {
  const apiCall = isDiscarded ? removeDiscard : addDiscard;
  await apiCall(token, roomId);
};
